<template>
    <div class="header-wrap">
        <div class="header">
            <a :href="webRoot" class="logo">
                <img :src="imgLogo"/>
            </a>
            <div class="search">
                <div class="search-box">
                    <Select class="select-type"  @on-change="getSearchHolderItem()" v-model="defaultSearchHolder.hotWordTypeName" style="width: 80px">
                        <Option :value="item.hotWordTypeName" :key="item.hotWordTypeName" v-for="(item, index) in searchHolder">{{item.hotWordTypeName}}</Option>
                    </Select>
                    <input type="text" :placeholder="defaultSearchHolder.placeHolder" v-model="keyword"/>
                    <button @click="goSearch"><i></i></button>
                </div>
                <div class="hot-words">
                    <a target="_blank" :href="returnHotWordsLink(item.hotWord)" v-for="item in defaultSearchHolder.hotWordVOList">{{item.hotWord}}</a>
                </div>
            </div>
            <div class="hot-line">
                <img :src="hot_line" alt="">
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import url from '../../../config/url';
    import common from '../../../static/js/common'
    /*import {select, option} from "iview"*/
    export default {
        components :{
            /*select: select,
            option: option*/
        },
        data() {
            return {
                imgLogo:  url.static + "/img/logo_main.png",
                hot_line : url.static + "/img/hot_line.png",
                webRoot: window.commonRoot + "/" + window.areaPinyin,
                searchHolderItem:{},
                defaultSearchHolder:{
                    hotWordTypeName: "诊所",
                    placeHolder: "请输入诊所名称，科室名称、医生名称",
                    targetUrl: "",
                },
                searchHolder:[{
                    hotWordTypeName: "",
                    placeHolder: "",
                }],
                keyword: this.$store.state.keyWord
            }
        },
        created: function () {
            this.getHotWord();
        },
        methods: {
            getHotWord(){
                var _this = this;
                axios.get(url.getHotWord)
                    .then(function (response) {
                        if(response.data.status == "SUCCESS" && response.data.result.length > 0){
                            _this.searchHolder = response.data.result;
                            var path = (_this.$route.path).toLocaleLowerCase();
                            var pathType = "index";
                            if(path.indexOf("doctor") > 0){
                                pathType = "doctor";
                            }else if(path.indexOf("clinic") > 0){
                                pathType = "clinic";
                            }else if(path.indexOf("knowledge") > 0){
                                pathType = "knowledge";
                            }else if(path.indexOf("diseaselist") > 0){
                                pathType = "diseaselist";
                            }else if(path.indexOf("list") > 0){
                                pathType = "list";
                            }
                            _this.searchHolder.forEach(function (value,index) {
                                if(value.hotWordTypeName == "综合"){
                                    _this.searchHolder[index].placeHolder = "请输入疾病名称，病症名称，药品地址，诊所名称，医生名称";
                                    if(pathType == "index"){
                                        _this.defaultSearchHolder.placeHolder=  "请输入疾病名称，病症名称，药品地址，诊所名称，医生名称";
                                        _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                        _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                        _this.defaultSearchHolder.sorting = value.sorting;
                                        _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                        _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                                    }
                                }else if(value.hotWordTypeName == "诊所"){
                                    _this.searchHolder[index].placeHolder = "请输入诊所名称，科室名称、医生名称";
                                    if(pathType == "clinic" || pathType == "index"){
                                        _this.defaultSearchHolder.placeHolder=  "请输入诊所名称，科室名称、医生名称";
                                        _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                        _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                        _this.defaultSearchHolder.sorting = value.sorting;
                                        _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                        _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                                    }
                                }else if(value.hotWordTypeName == "医生"){
                                    _this.searchHolder[index].placeHolder = "请输入医生名称，科室名称";
                                    if(pathType == "doctor"){
                                        _this.defaultSearchHolder.placeHolder=  "请输入医生名称，科室名称";
                                        _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                        _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                        _this.defaultSearchHolder.sorting = value.sorting;
                                        _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                        _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                                    }
                                }else if(value.hotWordTypeName == "药品"){
                                    _this.searchHolder[index].placeHolder = "请输入药品名称";
                                    if(pathType == "knowledge"){
                                        _this.defaultSearchHolder.placeHolder=  "请输入药品名称";
                                        _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                        _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                        _this.defaultSearchHolder.sorting = value.sorting;
                                        _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                        _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                                    }

                                }else if(value.hotWordTypeName == "疾病"){
                                    _this.searchHolder[index].placeHolder = "请输入疾病名称";
                                    if(pathType == "diseaselist"){
                                        _this.defaultSearchHolder.placeHolder=  "请输入疾病名称";
                                        _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                        _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                        _this.defaultSearchHolder.sorting = value.sorting;
                                        _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                        _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                                    }
                                }else if(value.hotWordTypeName == "产品"){
                                    _this.searchHolder[index].placeHolder = "请输入产品名称";
                                    if(pathType == "list"){
                                        _this.defaultSearchHolder.placeHolder=  "请输入产品名称";
                                        _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                        _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                        _this.defaultSearchHolder.sorting = value.sorting;
                                        _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                        _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                                    }
                                }
                            });
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error('数据获取失败,请稍后再试!');
                    });
            },
            getSearchHolderItem(){
                var _this = this;
                _this.searchHolder.forEach(function (value) {
                    if(value.hotWordTypeName == _this.defaultSearchHolder.hotWordTypeName){
                        _this.defaultSearchHolder.placeHolder = value.placeHolder;
                        _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                        _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                        _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                        _this.defaultSearchHolder.targetUrl = value.targetUrl;
                    }
                });
            },
            returnHotWordsLink(hotWord){
                var str = "";
                if(this.defaultSearchHolder.hotWordTypeName == "产品"){
                    str = url.listRoot+ "/list/sou" + encodeURIComponent(hotWord);
                }else if(this.defaultSearchHolder.hotWordTypeName == "药品"){
                    str = url.commonRoot+ "/knowledge/sou" + encodeURIComponent(hotWord);
                }else{
                    str = url.commonRoot + "/" + this.defaultSearchHolder.targetUrl + "/" + window.areaPinyin + "/sou" + encodeURIComponent(hotWord)
                }
                return str;
            },
            goSearch(){
                if($.trim(this.keyword).length > 0){
                    if(this.defaultSearchHolder.hotWordTypeName == "产品"){
                        window.open(url.listRoot+ "/list/sou" + encodeURIComponent($.trim(this.keyword)));
                    }else if(this.defaultSearchHolder.hotWordTypeName == "药品"){
                        window.open(url.commonRoot + "/" + this.defaultSearchHolder.targetUrl + "/sou" + encodeURIComponent($.trim(this.keyword)));
                    }else{
                        window.open(url.commonRoot + "/" + this.defaultSearchHolder.targetUrl + "/" + window.areaPinyin + "/sou" + encodeURIComponent($.trim(this.keyword)));
                    }
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../static/scss/page/pageHeaderBar";
</style>
<style lang="scss">
    ::-webkit-input-placeholder{
        color: #999;
    }
    ::placeholder{
        color: #999;
    }
    :-moz-placeholder{
        color: #999;
    }
    :-ms-input-placeholder{
        color: #999;
    }
    .select-type{
        float: left;
        .ivu-select-selection{
            height: 42px !important;
            line-height: 42px !important;
            border-radius: 0px;
            border: 2px solid #ff8e42;
            border-color: #ff8e42 !important;
            border-right: 0;
            box-shadow: none !important;
            .ivu-select-selected-value{
                text-align: center;
                color: #333;
                font-size: 14px !important;
                height: 42px !important;;
                line-height: 39px !important;
            }
        }
        .ivu-select-dropdown{
            padding: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Common/pageHeaderBar.vue